module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cc-27d55bfa0a8b66542f74f3fc7049997c.svg";